import { Page, IFilter } from './types';
import { classToPlain } from 'class-transformer';

const clear = (obj: any) => {
  for (var propName in obj) {
    if (obj[propName] === null || obj[propName] === undefined|| obj[propName] === '') {
      delete obj[propName];
    }
  }
  return obj
}


export const buildParams = (filters: IFilter, page: Page) => {

  return { 
    params: {
      ...classToPlain(page),
      ...classToPlain(clear(filters)),
    } 
  }
}

export const buildParamsNotPaged = (filters: IFilter) => {

  return { 
    params: {
      ...classToPlain(clear(filters)),
    } 
  }
}